export default "__VITE_ASSET__aVXm6vTp__"